import { useEffect, useState } from "react"
import { Input } from "./ui/shadcn/input"
import { Checkbox } from "./ui/shadcn/checkbox"
import { Switch } from "./ui/shadcn/switch"

export default function CtegoryEditor({ defaultValue, onChange }) {
    const [category, setCategory] = useState({
        name: 'New Category',
        allowed_types: ['*/*'],
        allow_wsc_import: false,
        vectorize: false,
        ...(defaultValue || {})
    })

    const allowedTypes = {
        'image/*': 'Image',
        'video/*': 'Video',
        'audio/*': 'Audio',
        'image/*,video/*,audio/*': 'All Media',
        '*/*': 'All',
    }
    
    useEffect(()=>{
        if(onChange) onChange(category)
    },[category])

    return (
        <div className='flex flex-col gap-4 w-full h-full p-4 overflow-y-auto'>
            <div className='flex flex-col gap-2'>
                <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                <Input name='name' defaultValue={category.name} onChange={(e)=>setCategory(prev => ({...prev, name: e.target.value}))} autoComplete="off" />
            </div>

            <div className='flex items-center gap-2'>
                <Switch id="vectorize-assets" checked={category.vectorize} onCheckedChange={(checked) => setCategory(prev => ({...prev, vectorize: checked}))} />
                <label htmlFor="vectorize" className='text-xs text-secondary-foreground'>Vectorize Assets</label>
            </div>

            <div className='flex flex-col gap-2'>
                <label className='text-xs text-secondary-foreground'>Allowed Types</label>
                {Object.keys(allowedTypes).map(type => (
                    <div key={type} className='flex items-center cursor-pointer'>
                        <Checkbox id={`allowed_types-${type}`} name='allowed_types' checked={category.allowed_types.includes(type)} onCheckedChange={(checked) => setCategory(prev => ({...prev, allowed_types: checked ? [...prev.allowed_types, type] : prev.allowed_types.filter(t => t !== type)}))} />
                        <label htmlFor={`allowed_types-${type}`} className='pl-2 text-xs text-secondary-foreground capitalize select-none'>{allowedTypes[type]}</label>
                    </div>
                ))}
            </div>
            
            

            <div className='flex items-center cursor-pointer'>
                <Checkbox id='allow_wsc_import' name='allow_wsc_import' checked={category.allow_wsc_import} onCheckedChange={(checked) => setCategory(prev => ({...prev, allow_wsc_import: checked}))} />
                <label htmlFor='allow_wsc_import' className='pl-2 text-xs text-secondary-foreground capitalize select-none'>Allow WSC Import</label>
            </div>
        </div>
    )
}